// Shared field definitions for the Cargo module (entry form + planning display)

export const DIRECTIONS = [
  { value: "import", label: "Import" },
  { value: "export", label: "Export" },
];

export const STATUSES = [
  { value: "booked", label: "Booked" },
  { value: "received", label: "Received" },
  { value: "departed", label: "Departed" },
  { value: "delivered", label: "Delivered" },
];

export const STATUS_STYLES = {
  booked: "bg-slate-100 text-slate-700 border-slate-200",
  received: "bg-blue-100 text-blue-700 border-blue-200",
  departed: "bg-amber-100 text-amber-700 border-amber-200",
  delivered: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const FIELD_GROUPS = [
  {
    title: "General",
    fields: [
      { key: "direction", label: "Direction", type: "select", options: DIRECTIONS },
      { key: "shipment_id", label: "Shipment ID / AWB N°", type: "text" },
      { key: "shipment_date", label: "Shipment Date", type: "date" },
      { key: "split_cargo", label: "Split Cargo", type: "checkbox" },
      { key: "split_count", label: "Split Count", type: "number" },
    ],
  },
  {
    title: "Shipment Information",
    fields: [
      { key: "airline", label: "Airline", type: "text" },
      { key: "flight_no", label: "Flight N°", type: "text" },
      { key: "origin", label: "Origin", type: "text" },
      { key: "destination", label: "Destination", type: "text" },
    ],
  },
  {
    title: "Cargo",
    fields: [
      { key: "weight_kg", label: "Cargo Weight (kg)", type: "number" },
      { key: "pieces", label: "N° of Pieces", type: "number" },
      { key: "description", label: "Description / Type of Cargo", type: "text" },
    ],
  },
  {
    title: "Customs",
    fields: [
      { key: "customs_eu", label: "EU", type: "checkbox" },
      { key: "customs_t1", label: "T1", type: "checkbox" },
      { key: "editing_fee", label: "Editing Fee (€)", type: "number" },
      { key: "mrn_no", label: "Document MRN N°", type: "text" },
    ],
  },
  {
    title: "Special Handling",
    fields: [
      { key: "temp_controlled", label: "Temperature Controlled", type: "checkbox" },
      { key: "temp_c", label: "Temperature (°C)", type: "text" },
      { key: "hazardous", label: "Hazardous (DG)", type: "checkbox" },
      { key: "dg_un_no", label: "UN / NA / ID N°", type: "text" },
    ],
  },
  {
    title: "Origin / Destination of Goods",
    fields: [
      { key: "goods_country", label: "Country", type: "text" },
      { key: "goods_city", label: "City", type: "text" },
      { key: "transit", label: "Transit", type: "text" },
    ],
  },
  {
    title: "Parties",
    fields: [
      { key: "operator", label: "Operator", type: "text" },
      { key: "consignee", label: "Consignee", type: "text" },
      { key: "customs_agency", label: "Customs Agency", type: "text" },
      { key: "contact_email", label: "Contact Email", type: "text" },
    ],
  },
  {
    title: "Storage",
    fields: [
      { key: "storage_in_date", label: "In — Date", type: "date" },
      { key: "storage_in_hour", label: "In — Hour", type: "time" },
      { key: "storage_out_date", label: "Out — Date", type: "date" },
      { key: "storage_out_hour", label: "Out — Hour", type: "time" },
      { key: "storage_days", label: "Days", type: "number" },
    ],
  },
  {
    title: "Status & Notes",
    fields: [
      { key: "status", label: "Status", type: "select", options: STATUSES },
      { key: "remark", label: "Remark", type: "textarea" },
    ],
  },
];

export const emptyEntry = () => {
  const e = {};
  FIELD_GROUPS.forEach((g) =>
    g.fields.forEach((f) => {
      if (f.type === "checkbox") e[f.key] = false;
      else e[f.key] = "";
    })
  );
  e.direction = "import";
  e.status = "booked";
  return e;
};
